export enum EmailTypeEnum {
  Created = 'created',
  Assigned = 'assigned',
  StatusChanged = 'statusChanged',
  Edited = 'edited',
  Unassigned = 'unassigned',
  Escalation = 'escalation',
}

export enum EmailTargetTypeEnum {
  Admin = 'admin',
  AssignedTeam = 'assignedTeam',
  AssignedUser = 'assignedUser',
  User = 'user',
}
